import { API_AUTH, SITA } from "../auth/variables.tsx";
import { redireccionar } from "./funciones.tsx"
import { Toast } from "./toast.tsx";

interface headerParms{
    user: Usuario | undefined
    titulo?: string
}
    
export const Header = ({user,titulo=""}:headerParms)=>{
    
        const logout = ()=>{
            let init = {
                method: "POST",
                body: JSON.stringify({}),
                header:{
                    "Content-Type":"aplication/json"
                }
            };
            fetch(API_AUTH + "/logout",init)
            .then(response=>response.json())
            .catch(err=>console.log(err))
            .then(data=>{
                if(data.status === "ok"){
                    //usuario deslogeado 
                    Toast.fire({
                        icon:"success",
                        title:"LogOut",
                        text:"Se cerro la sesión correctamente"
                    })
                    redireccionar(SITA + "/login");
                }
                else{
                    //no se cerro la sesión... el usuario continua logeado
                    Toast.fire({
                        icon:"error",
                        title:"LogOut",
                        text:"No se logró cerrar la sesión"
                    })
                }
            })
    
        }
    
    return(
        <div id="header">
                    <div className="logo" onClick={()=>redireccionar(SITA)}>Si.T.A.</div>
                    <h5 style={{fontStyle:"italic",fontWeight:"bold"}}>
                        {titulo}
                    </h5>
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="mx-1">
                            {user?.Nombre}
                        </div>

                        <button 
                            type="button"
                            className={user?"btn btn-sm btn-outline-primary mx-1":"btn btn-sm btn-outline-secondary mx-1"}
                            onClick={user?()=>redireccionar(SITA + "/perfil"):()=>{}}
                        ><i className="bi bi-person-vcard"></i></button>
                        
                        <button 
                            type="button" 
                            className={user?"btn btn-sm btn-danger":"btn btn-sm btn-primary"}
                            onClick={user?logout:()=>redireccionar(SITA + "/login")}
                        >
                            {user?"Salir":"LogIn"}
                        </button>
                    </div>
                </div>
    )
}